module.exports = {
  footerText: 'Copyright YDEO © 2022',
}
